import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './TableContainer.module.less';

interface TableContainerProps {
  className?: string;
  size?: 'small' | 'normal';
  filled?: boolean;
  thLighten?: boolean;
}

const TableContainer: FC<TableContainerProps> = ({ children, className, filled, thLighten, size = 'normal' }) => {
  return (
    <div
      className={clsx(styles.table, styles[size], thLighten && styles.thLighten, filled && styles.filled, className)}
    >
      {children}
    </div>
  );
};

export default TableContainer;
